module.exports = __webpack_public_path__ + "static/media/ic_last_active.82cf601d.svg";